// extracted by mini-css-extract-plugin
module.exports = {"highlight-translucent":"template11_highlight-translucent__htF3t","highlight":"template11_highlight__0k2e3"};